module.exports = __webpack_public_path__ + "img/profile.0b82f3c8.png";